import { formatUtcDateTimeAsSaoPaulo, BRASILIA_WALL_CLOCK_DATETIME_RE } from './formatTime';

/**
 * Valores que parecem instante (data + hora), excluindo só-dia AAAA-MM-DD e o já normalizado BR.
 */
function isApiDateTimeLikeString(value) {
  if (typeof value !== 'string') return false;
  const t = value.trim();
  if (!t || BRASILIA_WALL_CLOCK_DATETIME_RE.test(t)) return false;
  if (/^\d{4}-\d{2}-\d{2}$/.test(t)) return false;
  return /\d{4}-\d{2}-\d{2}[T ]\d{1,2}:\d{2}/.test(t);
}

function shouldNormalizeField(key, value) {
  if (!isApiDateTimeLikeString(value)) return false;
  if (key.endsWith('_at')) return true;
  if (key === 'due_date') return true;
  return false;
}

/**
 * Percorre objetos/arrays da resposta JSON e reescreve strings de data/hora para
 * horário de exibição em Brasília (America/Sao_Paulo), assumindo UTC quando não há fuso.
 *
 * Chamado pelo interceptor do axios em `axios/config.js`.
 */
export function transformApiResponseDatesInPlace(node, seen = new WeakSet()) {
  if (node == null || typeof node !== 'object') return;
  if (seen.has(node)) return;
  if (node instanceof Date) return;
  seen.add(node);

  if (Array.isArray(node)) {
    for (let i = 0; i < node.length; i += 1) {
      transformApiResponseDatesInPlace(node[i], seen);
    }
    return;
  }

  const keys = Object.keys(node);
  for (let i = 0; i < keys.length; i += 1) {
    const key = keys[i];
    const val = node[key];

    if (typeof val === 'string' && shouldNormalizeField(key, val)) {
      const normalized = formatUtcDateTimeAsSaoPaulo(val);
      if (normalized) {
        node[key] = normalized;
      }
    } else if (val && typeof val === 'object') {
      transformApiResponseDatesInPlace(val, seen);
    }
  }
}
